<template>
  <div id="app">
    <router-view />
  </div>
</template>
<script>
export default {
  mounted() {
  }
}
</script>
<style scoped>
#app {
  width: 100vw;
  height: 100vh;
  background-color: #020308;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  box-sizing: content-box
}

@import "./assets/css/base.css";
@import "./assets/css/reset.css";
</style> 